import React, { useEffect, useState } from "react";
import { business, locations, services } from "../data/jalRoData";

const buildWhatsAppText = (data) => {
  const lines = [
    "New enquiry for Jal RO System",
    `Name: ${data.name || ""}`,
    `Phone: ${data.phone || ""}`,
    `Service: ${data.service || ""}`,
    `Location: ${data.location || ""}`,
    `Message: ${data.message || ""}`,
  ];

  return `${business.whatsapp}?text=${encodeURIComponent(lines.join("\n"))}`;
};

export const InquiryForm = ({ compact = false, source = "Website Form", onSuccess }) => {
  const [status, setStatus] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    const formData = new FormData(form);
    formData.set("source", source);

    try {
      const response = await fetch(business.formAction, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Unable to send enquiry");
      }

      setStatus("Thank you. Your enquiry has been sent.");
      form.reset();
      if (onSuccess) onSuccess();
    } catch (error) {
      const data = Object.fromEntries(formData.entries());
      setStatus("Unable to send email here. Please use WhatsApp or call now.");
      window.open(buildWhatsAppText(data), "_blank", "noopener,noreferrer");
    }
  };

  return (
    <form className={`jal-form ${compact ? "jal-form-compact" : ""}`} onSubmit={handleSubmit}>
      <h3>Book RO Service</h3>
      <input type="hidden" name="source" value={source} />
      <div className="row g-3">
        <div className="col-md-6">
          <input name="name" type="text" placeholder="Your Name" required />
        </div>
        <div className="col-md-6">
          <input name="phone" type="tel" placeholder="Phone Number" required />
        </div>
        <div className="col-md-6">
          <select name="service" defaultValue="" required>
            <option value="" disabled>
              Select Service
            </option>
            {services.map((service) => (
              <option key={service}>{service}</option>
            ))}
          </select>
        </div>
        <div className="col-md-6">
          <select name="location" defaultValue="" required>
            <option value="" disabled>
              Select Location
            </option>
            {locations.map((location) => (
              <option key={location}>{location}</option>
            ))}
          </select>
        </div>
        <div className="col-12">
          <textarea name="message" placeholder="Tell us about your RO issue" rows={compact ? 3 : 4} />
        </div>
        <div className="col-12">
          <button type="submit" className="jal-primary-btn">
            Submit Enquiry
          </button>
          {status && <p className="jal-form-status">{status}</p>}
        </div>
      </div>
    </form>
  );
};

export const EnquiryPopup = () => {
  const [visible, setVisible] = useState(false);
  const [shownCount, setShownCount] = useState(() => {
    const saved = window.localStorage.getItem("jalro_popup_count");
    return saved ? Number(saved) : 0;
  });

  useEffect(() => {
    if (visible || shownCount >= 2) return undefined;

    const timer = window.setTimeout(() => {
      const nextCount = shownCount + 1;
      window.localStorage.setItem("jalro_popup_count", String(nextCount));
      setShownCount(nextCount);
      setVisible(true);
    }, shownCount === 0 ? 8000 : 15000);

    return () => window.clearTimeout(timer);
  }, [shownCount, visible]);

  const stopPopup = () => {
    window.localStorage.setItem("jalro_popup_count", "2");
    setShownCount(2);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="jal-popup-backdrop" role="dialog" aria-modal="true">
      <div className="jal-popup">
        <button className="jal-popup-close" type="button" onClick={() => setVisible(false)} aria-label="Close enquiry popup">
          <i className="fas fa-times" />
        </button>
        <div className="jal-popup-copy">
          <span>Quick Enquiry</span>
          <h2>Need RO service today?</h2>
          <p>Submit your details and our team will contact you for fast doorstep service.</p>
        </div>
        <InquiryForm compact source="Popup Enquiry" onSuccess={stopPopup} />
      </div>
    </div>
  );
};
